import React from "react"
import Img from "gatsby-image/withIEPolyfill"
import { Eyebrow, CTA, GridLines, Headline } from "@shared"
import { css, logTool, revertSlug } from "@jsUtils"
import { PageSection } from "../PageSection"

import Styles from "./spotlight.module.scss"

const log = logTool()

/**
 * Product Spotlight is a product callout
 * @param {object} props - React props
 */
const Spotlight = props => {
  const {
    color,
    theme,
    layout,
    eyebrow,
    title,
    headline,
    description,
    ctaLink,
    ctaLabel,
    image,
    isTM
  } = props
  const [ready, setReady] = React.useState(false)

  const SpotlightImage = (
    <div className={Styles.imageWrapper}>
      {image ? <Img alt={image.title} className={Styles.image} fluid={image.fluid} /> : ""}
    </div>
  )

  console.log("Spotlight:", props)

  return (
    <PageSection
      className={css(Styles.section, ready && Styles.ready, Styles.spotlightSection)}
      theme={theme}
      ready={ready}
      onReady={() => {
        setReady(true)
      }}
    >
      <GridLines theme={theme} />
      <div className={css(Styles.wrapper, Styles[`layout_${layout}`], Styles[`color_${color}`])}>
        <div className={css(Styles.circleWrapper, `spotlightIEOverride`)}>
          <div className={Styles.circle}>{layout !== "center" ? SpotlightImage : ""}</div>
        </div>
        <div className={Styles.content}>
          <div className={Styles.contentWrapper}>
            <Eyebrow color={color}>{eyebrow}</Eyebrow>
            <div className={Styles.mainContent}>
              <Headline size={1} className={Styles.headlinePrimary} color={color}>
                {title}
                {isTM ? <sup>TM</sup> : null}
              </Headline>
              <Headline size={1} className={Styles.headline}>
                {headline}
              </Headline>
              <p className={Styles.body}>{description}</p>
              {ctaLabel ? (
                <CTA
                  ready={ready}
                  className={Styles.cta}
                  color={color}
                  to={ctaLink}
                  ascope="SPOTLIGHT"
                  adata={{
                    content: `${ctaLabel} - ${revertSlug(ctaLink)}`
                  }}
                >
                  {ctaLabel}
                </CTA>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
        {layout === "center" ? SpotlightImage : ""}
      </div>
    </PageSection>
  )
}

Spotlight.defaultProps = {
  color: "fluro",
  layout: "right"
}

export default Spotlight
